import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

function Sitemap() {
  const sitemapData = [
    {
      title: "Diensten",
      links: [
        { name: "Renovatie", path: "/renovatie" },
        { name: "Groepenkast Vervangen", path: "/groepenkast-vervangen" },
        { name: "Elektra aanleggen", path: "/elektra-aanleggen" },
        { name: "Kookgroep Aansluiten", path: "/kookgroep-aansluiten" },
        { name: "Elektra Renovatie", path: "/elektra-renovatie" },
        { name: "3-Fase Aansluiting", path: "/3-fase-aansluiting" },
        { name: "Laadpaal", path: "/laadpaal" },
        { name: "Zonnepanelen", path: "/zonnepanelen" },
        { name: "Stopcontacten Plaatsen", path: "/stopcontacten-plaatsen" },
        { name: "Elektra inspectie ", path: "/inspectie" },
      ],
    },
    {
      title: "Over Ons",
      links: [
        { name: "Ons Verhaal", path: "/ons-verhaal" },
        { name: "Vacatures", path: "/vacatures" },
        { name: "Contact", path: "/contact" },
        { name: "Klantenservice", path: "/klantenservice" },
      ],
    },
    {
      title: "Informatie",
      links: [
        { name: "Veelgestelde Vragen", path: "/veelgestelde-vragen" },
        { name: "Begrippen", path: "/begrippen" },
        { name: "Offerte Aanvragen", path: "/offerte" },
        { name: "Aardpen", path: "/begrippen/aardpen" },
        { name: "Fase", path: "/begrippen/fase" },
        { name: "Fasedraad", path: "/begrippen/fasedraad" },
        { name: "Installatiekast", path: "/begrippen/installatiekast" },
        { name: "Aarddraad", path: "/begrippen/aarddraad" },
        { name: "Aardlekschakelaar", path: "/begrippen/aardlekschakelaar" },
        { name: "Ampere", path: "/begrippen/ampere" },
        { name: "Bekabeling", path: "/begrippen/bekabeling" },
        { name: "Dimmer", path: "/begrippen/dimmer" },
        { name: "Elektriciteit", path: "/begrippen/elektriciteit" },
        { name: "Groepenkast", path: "/begrippen/groepenkast" },
        { name: "Installatieautomaat", path: "/begrippen/installatieautomaat" },
        { name: "Kortsluiting", path: "/begrippen/kortsluiting" },
        { name: "Krachtstroom", path: "/begrippen/krachtstroom" },
        { name: "Laadpaal", path: "/begrippen/laadpaal" },
        { name: "Nuldraad", path: "/begrippen/nuldraad" },
        { name: "Overspanning", path: "/begrippen/overspanning" },
        { name: "Schakelaar", path: "/begrippen/schakelaar" },
        { name: "Stopcontact", path: "/begrippen/stopcontact" },
        { name: "Volt", path: "/begrippen/volt" },
        { name: "Watt", path: "/begrippen/watt" },
        { name: "Zonne Energie", path: "/begrippen/zonne-energie" },
      ],
    },
    {
      title: "Juridisch",
      links: [
        { name: "Privacy Policy", path: "/privacy" },
        { name: "Algemene Voorwaarden", path: "/voorwaarden" },
        { name: "Cookie Beleid", path: "/cookies" },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
       <SEO
        title="Sitemap - elektricieninarnhem026.nl"
        description="Alle links van elektricieninarnhem026.nl in een sitemap."
        image="/images/banner.png"
      />
      <Header />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-20 pt-16 md:pt-24">
        <h1 className="font-bold text-black leading-[1.25] text-[28px] lg:text-[36px] text-[#17354A] block mb-4 leading-[35px] text-[2rem] md:inline-block md:mb-5 md:text-[44px] md:leading-[42px] lg:block">
          Sitemap
        </h1>

        <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {sitemapData.map((section) => (
              <div
                key={section.title}
                className="bg-[#F8F9FB] h-fit p-6 rounded-lg shadow-sm"
              >
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  {section.title}
                </h2>
                <ul className="space-y-2">
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-gray-600 hover:underline transition-colors duration-200"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Sitemap;
